export default __webpack_public_path__ + "static/media/c0ad2c027c33a089925952735e86aa68.png";